/*
Copyright (C) 2017  Cloudbase Solutions SRL
Copyright (C) 2026  Integrated Tech9labs Pvt. Ltd.
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import { observer } from "mobx-react";
import React from "react";

import DashboardContent from "@src/components/modules/DashboardModule/DashboardContent";
import dashboardStore from "@src/components/modules/DashboardModule/DashboardStore";
import { buildEstate } from "@src/components/modules/DashboardModule/dashboardData";
import liveStore from "@src/components/modules/LiveModule/LiveStore";
import { providerLabel } from "@src/components/modules/LiveModule/liveUtils";
import Navigation from "@src/components/modules/NavigationModule/Navigation";
import MainTemplate from "@src/components/modules/TemplateModule/MainTemplate";
import PageHeader from "@src/components/smart/PageHeader";
import endpointStore from "@src/stores/EndpointStore";

/*
 * The management dashboard: the migration estate at a glance. What is running comes from the
 * live store (5 s), the rest from the dashboard store (60 s).
 */
const DashboardPage = observer(() => {
  const [now, setNow] = React.useState(Date.now());

  React.useEffect(() => {
    document.title = "Dashboard · SwiftIQ";
    dashboardStore.start();
    const tick = window.setInterval(() => setNow(Date.now()), 5000);
    return () => {
      dashboardStore.stop();
      window.clearInterval(tick);
    };
  }, []);

  const invalidEndpoints = endpointStore.multiValidation
    .filter(v => v.validation && !v.validation.valid)
    .map(v => v.endpoint);
  const estate = buildEstate({
    now,
    transfers: liveStore.transfers,
    deployments: liveStore.deployments,
    endpoints: endpointStore.endpoints,
    pools: dashboardStore.pools,
    executions: dashboardStore.executions,
    copied: dashboardStore.copied,
    schedules: dashboardStore.schedules,
    invalidEndpoints,
    providerLabel,
  });

  return (
    <MainTemplate
      navigationComponent={<Navigation currentPage="dashboard" />}
      listNoMargin
      headerComponent={
        <PageHeader
          title="Dashboard"
          subtitle="Your migration estate at a glance."
          onProjectChange={() => dashboardStore.reset()}
        />
      }
      listComponent={
        <DashboardContent
          estate={estate}
          loaded={liveStore.loaded && dashboardStore.loaded}
          live={liveStore.running}
          finishedToday={liveStore.recentlyFinished.length}
          now={now}
        />
      }
    />
  );
});

export default DashboardPage;
